import logo from "./logo.svg";
import "./App.css";
import HomePage from "./Pages/Home.page.jsx";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useLocation } from 'react-router-dom';

import { Box } from "@mui/material";
import DrawerAppBar from "./Components/Common/AppBar.component.jsx";
import UserPage from "./Pages/User.page.jsx";
import EventPage from "./Pages/Event.page.jsx";
import FlokiPage from "./Pages/FlokiTools.page.jsx";

import Footer from "./Components/Common/Footer.component.jsx";
import TokenPage from "./Pages/Token.page.jsx";
import { ToastContainer } from "react-toastify";
import PrivateRoute from "./Components/Common/PrivateRoute.jsx";
import LoginPage from "./Pages/Login.page.jsx";
import { useContext, useEffect } from "react";
import { checkIfCookieExpired } from "./utils/cookies.js";
import { AuthContext } from "./state/context/auth.context.js";
import { useTheme as useCustomTheme } from './contexts/ThemeContext.jsx';
import TradingToolsPage from "./Pages/TradingTools.page.jsx";
import LeaderboardPage from "./Pages/LeaderboardPage.page.jsx";
import TokenExploreList from "./Pages/TokenExplore.page.jsx";
import LogViewer from "./Pages/Logs.page.jsx";
import CreatePage from "./Pages/Create.page.jsx";
import AnalyticsPage from "./Pages/Analytics.page.jsx";
import ExplorerRouter from "./Explorer/ExplorerRouter.jsx";

// Import i18n configuration
import './i18n';
import { LanguageProvider } from './state/context/language.context.js';
import { ThemeProvider } from './contexts/ThemeContext.jsx';


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]); // Only run effect when pathname changes

  return null; // This component doesn't render anything visible
}

function MainSiteLayout({ children }) {
  const location = useLocation();
  const isExplorerRoute = location.pathname.startsWith('/explorer');

  if (isExplorerRoute) {
    // For Explorer routes, don't show main site AppBar and Footer
    return children;
  }

  // For main site routes, show AppBar and Footer
  return (
    <>
      <DrawerAppBar />
      <Box sx={{ height: "70px" }} />
      <Box>
        {children}
      </Box>
      <Footer />
    </>
  );
}

function AppContent() {
  const { logout, state } = useContext(AuthContext);
  const { isConnected } = state.user || {};
  const { isDarkMode } = useCustomTheme();

  useEffect(() => {
    const isExpired = checkIfCookieExpired("userToken");
    if (isExpired && isConnected) {
      logout();
    }
  }, [isConnected, logout]);

  // return <MaintenancePage />;

  return (
    <>
      <LanguageProvider>
        <Router>
          <ScrollToTop />
          <MainSiteLayout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/users/:user" element={<UserPage />} />
              <Route path="/tokens/:token" element={<TokenPage />} />
              <Route path="/tokens" element={<TokenExploreList />} />
              <Route path="/events" element={<EventPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/trading-tools" element={<TradingToolsPage />} />
              <Route path="/users/leaderboard" element={<LeaderboardPage />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route path="/admin/logs" element={<LogViewer />} />
              <Route element={<PrivateRoute />}>
                <Route path="/floki" element={<FlokiPage />} />
                <Route path="/tokens/create" element={<CreatePage />} />
              </Route>
              {/* Explorer sub-site routes */}
              <Route path="/explorer/*" element={<ExplorerRouter />} />
            </Routes>
          </MainSiteLayout>
          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme={isDarkMode ? "dark" : "light"}
          />
        </Router>
      </LanguageProvider>
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
